import React from 'react';
import LoginUser from '../../components/Login';
import AuthWrapper from '../../layout/auth/auth-wrapper';

const Login = () => {
  return (
    <AuthWrapper>
      <LoginUser />
    </AuthWrapper>
  );
};

export default Login;
